<template>
  <section>
    <div class="z-card border-0 integration-page">
      <article>
        <h4>{{ $t('integration.api.get_message_state') }}</h4>

        <ul class="list-unstyled integration-list-info">
          <li><b>URL:</b> https://my.zorra.com/api/v1/mailing/single/state/{message_id}/li></li>
          <li><b>Content-Type:</b> application/json</li>
          <li><b>Method:</b> GET</li>
          <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
        </ul>
        <p>
          {{ $t('integration.api.answer_example') }}
        </p>
        <pre>                <code class="json hljs">
{
    <span class="hljs-attr">"success"</span>: <span class="hljs-literal">true</span>,
    <span class="hljs-attr">"state"</span>: <span class="hljs-string">"sent"</span>,
    <span class="hljs-attr">"message"</span>: {
        <span class="hljs-attr">"id"</span>: <span class="hljs-number">47629</span>,
        <span class="hljs-attr">"type"</span>: <span class="hljs-string">"sms"</span>,
        <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79180000000"</span>,
        <span class="hljs-attr">"state"</span>: <span class="hljs-string">"sent"</span>,
        <span class="hljs-attr">"cost"</span>: <span class="hljs-string">"0.000000"</span>,
        <span class="hljs-attr">"mailing_id"</span>: <span class="hljs-number">100200300</span>
    }
}
                </code>
            </pre>
      </article>

      <article>
        <h4>{{ $t('integration.api.get_mailing_state') }}</h4>

        <ul class="list-unstyled integration-list-info">
          <li><b>URL:</b> https://my.zorra.com/api/v1/mailing/state/{mailing_id}</li>
          <li><b>Content-Type:</b> application/json</li>
          <li><b>Method:</b> GET</li>
          <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
        </ul>
        <p>
          {{ $t('integration.api.answer_example') }}
        </p>
        <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"success"</span>: <span class="hljs-literal">true</span>,
      <span class="hljs-attr">"state"</span>: <span class="hljs-string">"sent"</span>,
      <span class="hljs-attr">"messages"</span>: [
          {
              <span class="hljs-attr">"id"</span>: <span class="hljs-number">47629</span>,
              <span class="hljs-attr">"type"</span>: <span class="hljs-string">"sms"</span>,
              <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79180000000"</span>,
              <span class="hljs-attr">"state"</span>: <span class="hljs-string">"sent"</span>,
              <span class="hljs-attr">"cost"</span>: <span class="hljs-string">"0.000000"</span>
          }
      ]
  }
</code>
            </pre>
      </article>

      <article>
        <h4>{{ $t('integration.api.get_mailing_list') }}</h4>
        <ul class="list-unstyled integration-list-info">
          <li><b>URL:</b> https://my.zorra.com/api/v1/mailing</li>
          <li><b>Content-Type:</b> application/json</li>
          <li><b>Method:</b> GET</li>
          <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
        </ul>
        <p>
          {{ $t('integration.api.example') }}
        </p>
        <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"date_from"</span>: <span class="hljs-string">"2018-01-01 00:00"</span>,
      <span class="hljs-attr">"date_to"</span>: <span class="hljs-string">"2019-06-01 23:59"</span>,
      <span class="hljs-attr">"type"</span>: <span class="hljs-string">"sms"</span>
  }
</code>
            </pre>
        <p>{{ $t('integration.api.answer_example') }}</p>
        <pre>
<code class="json hljs">
  {
    <span class="hljs-attr">"success"</span>: <span class="hljs-literal">true</span>,
    <span class="hljs-attr">"data"</span>: [
      {
      <span class="hljs-attr">"source"</span>: <span class="hljs-string">"web"</span>,
      <span class="hljs-attr">"sender"</span>: <span class="hljs-string">"Dostavim"</span>,
      <span class="hljs-attr">"name"</span>: <span class="hljs-string">"test1"</span>,
      <span class="hljs-attr">"state"</span>: <span class="hljs-string">"sent"</span>,
      <span class="hljs-attr">"type"</span>: <span class="hljs-string">"sms"</span>,
      <span class="hljs-attr">"body"</span>: <span class="hljs-string">"test1"</span>,
      <span class="hljs-attr">"finished"</span>: <span class="hljs-number">4</span>,
      <span class="hljs-attr">"duration"</span>: <span class="hljs-literal">null</span>,
      <span class="hljs-attr">"blocked"</span>: <span class="hljs-number">5</span>
      },
      {
        <span class="hljs-attr">"source"</span>: <span class="hljs-string">"web"</span>,
        <span class="hljs-attr">"sender"</span>: <span class="hljs-string">"Dostavim"</span>,
        <span class="hljs-attr">"name"</span>: <span class="hljs-string">"test4"</span>,
        <span class="hljs-attr">"state"</span>: <span class="hljs-string">"sent"</span>,
        <span class="hljs-attr">"type"</span>: <span class="hljs-string">"sms"</span>,
        <span class="hljs-attr">"body"</span>: <span class="hljs-string">"test4"</span>,
        <span class="hljs-attr">"finished"</span>: <span class="hljs-number">1</span>,
        <span class="hljs-attr">"duration"</span>: <span class="hljs-literal">null</span>,
        <span class="hljs-attr">"blocked"</span>: <span class="hljs-number">3</span>
      },
      {
        <span class="hljs-attr">"source"</span>: <span class="hljs-string">"web"</span>,
        <span class="hljs-attr">"sender"</span>: <span class="hljs-string">"Dostavim"</span>,
        <span class="hljs-attr">"name"</span>: <span class="hljs-string">"test0"</span>,
        <span class="hljs-attr">"state"</span>: <span class="hljs-string">"sent"</span>,
        <span class="hljs-attr">"type"</span>: <span class="hljs-string">"sms"</span>,
        <span class="hljs-attr">"body"</span>: <span class="hljs-string">"test0"</span>,
        <span class="hljs-attr">"finished"</span>: <span class="hljs-number">2</span>,
        <span class="hljs-attr">"duration"</span>: <span class="hljs-literal">null</span>,
        <span class="hljs-attr">"blocked"</span>: <span class="hljs-number">1</span>
      },
      {
        <span class="hljs-attr">"source"</span>: <span class="hljs-string">"web"</span>,
        <span class="hljs-attr">"sender"</span>: <span class="hljs-string">"Dostavim"</span>,
        <span class="hljs-attr">"name"</span>: <span class="hljs-string">"test0"</span>,
        <span class="hljs-attr">"state"</span>: <span class="hljs-string">"sent"</span>,
        <span class="hljs-attr">"type"</span>: <span class="hljs-string">"sms"</span>,
        <span class="hljs-attr">"body"</span>: <span class="hljs-string">"test0"</span>,
        <span class="hljs-attr">"finished"</span>: <span class="hljs-number">2</span>,
        <span class="hljs-attr">"duration"</span>: <span class="hljs-literal">null</span>,
        <span class="hljs-attr">"blocked"</span>: <span class="hljs-number">1</span>
      }
    ]
  }

</code>
            </pre>
      </article>
    </div>
  </section>
</template>

<script>
  export default {};
</script>
<style lang="scss">
  @import '~@/assets/styles/scss/highlight/monokai';
  @import '~@/assets/styles/scss/pages/integration';
</style>
